import React from 'react';
import PropTypes from 'prop-types';

const MentalHealthCTA = ({ title, description, buttonText, buttonLink, onButtonClick }) => {
    const handleClick = () => {
        if (onButtonClick) {
            onButtonClick();
        } else if (buttonLink) {
            window.location.href = buttonLink;
        }
    };

    return (
        <section className="py-16 md:py-20 lg:py-24 bg-gray-50">
            <div className="container mx-auto px-4 md:px-8 max-w-6xl">
                <div className="text-center">
                    {/* Main Heading with Green Underline */}
                    <div className="mb-6 md:mb-8">
                        <h2 className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold primary-text leading-tight">
                            {title}
                        </h2>
                        {/* Green Underline */}
                        <div className="w-32 md:w-40 h-1 secondary-bg mx-auto"></div>
                    </div>

                    {/* Description */}
                    <p className="md:text-base lg:text-lg text-gray-700 leading-relaxed mb-8 md:mb-10 max-w-5xl mx-auto">
                        {description}
                    </p>

                    {/* CTA Button */}
                    <button
                        onClick={handleClick}
                        className="primary-bg text-white px-8 py-2 md:px-10 md:py-3 text-base md:text-lg font-semibold rounded-lg hover:opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl uppercase"
                    >
                        {buttonText}
                    </button>
                </div>
            </div>
        </section>
    );
};

MentalHealthCTA.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    buttonLink: PropTypes.string,
    onButtonClick: PropTypes.func,
};

MentalHealthCTA.defaultProps = {
    buttonLink: null,
    onButtonClick: null,
};

export default MentalHealthCTA;